import { makeVar } from '@apollo/client';
import buildNotification from 'utils/buildNotification';
import type {
  Notification,
  MutationaddNotificationArgs,
  MutationremoveNotificationArgs,
} from 'types/__generated__/graphql-global-types';

export const initialData: Notification[] = [];
export const notificationsVar = makeVar<Notification[]>(initialData);

export const readNotifications = (): Notification[] => {
  try {
    return notificationsVar();
  } catch {
    return [];
  }
};

export const writeNotifications = (notifications: Notification[]) => {
  notificationsVar(notifications);
};

export const resolvers = {
  Query: {
    notifications: () => readNotifications(),
  },

  Mutation: {
    addNotification: (_: never, args: MutationaddNotificationArgs) => {
      const { notification } = args;
      const notifications = readNotifications();

      try {
        const newNotifications = [...notifications, buildNotification(notification)];
        writeNotifications(newNotifications);
        return true;
      } catch {
        return false;
      }
    },

    removeNotification: (_: never, args: MutationremoveNotificationArgs) => {
      const { id } = args;
      const notifications = readNotifications();

      try {
        const newNotifications = notifications.filter((notification) => notification.id !== id);
        writeNotifications(newNotifications);
        return true;
      } catch {
        return false;
      }
    },
  },
};
